import axiosInstance from '../services/axiosInstance';
import { CompanySchool } from '../hooks/useCompany';

export const addCompanySchool = async (companyId: string, name: string) => {
  const { data: response } = await axiosInstance.post('/booking/schools', {
    companyId,
    name,
  });
  return response.data as {
    school: CompanySchool;
    schools: CompanySchool[];
    created: boolean;
  };
};

export const getSchoolBookingUsage = async (params: {
  companyId: string;
  schoolId: string;
  date?: string;
}) => {
  const { data: response } = await axiosInstance.get('/booking/school-booking-usage', {
    params,
  });
  return response.data as {
    countInMonth: number;
    slotsOnDate: Array<{
      id: string;
      date: string;
      startTime: string;
      endTime?: string;
      duration?: number;
    }>;
    maxPerMonth: number;
  };
};
